
// export const myGetter = ( state ) => {
//  return state
// }

export const generalInventory = state => state.generalInventory
export const generalInventoryPaginated = state => state.generalInventoryPaginated
export const generalInventoryisLoading = state => state.generalInventoryisLoading